import React from 'react';
import { HiLocationMarker } from 'react-icons/hi';
import { HiClock } from 'react-icons/hi2';
import Container from 'src/components/shared/Container';
import { PiUsersThreeFill } from 'react-icons/pi';
import { Button } from 'flowbite-react';
import dayjs from 'dayjs';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';

type UpcomingDriveCardProps = {
	id: string;
	image: string;
	title: string;
	location: string;
	time: Date;
	endTime: Date | null | string;
	isRegistered: boolean;
	totalParticipating: number;
};

const UpcomingDriveCard = ({
	id,
	image,
	title,
	location,
	time,
	endTime,
	isRegistered,
	totalParticipating,
}: UpcomingDriveCardProps) => {
	const navigate = useNavigate();
	const { isAccountManagerLoggedIn } = useUserContext();
	return (
		<Container className="w-full !px-0">
			<div className="max-w-[540px] mx-auto w-full flex justify-between rounded-[8px] bg-[#FFF] py-[24px] px-[14px] gap-3 md:gap-[20px] shadow-[0px_4px_6px_-2px_rgba(0,_0,_0,_0.05)]">
				<div>
					<div className="relative max-w-[115.246px]">
						<img src={image} className="max-w-[200px] w-full h-full min-w-[30%]" />
						<div className="absolute inset-0 flex items-center justify-center bg-opacity-75">
							<div className="text-center flex items-center justify-end flex-col h-full w-full pb-[10px]">
								<p className="text-[#6C6768] items-center font-[600] text-[8vw] tsm:text-[48px] leading-[32px] md:leading-[48px]">
									{dayjs(time).format('DD')}
								</p>
								<p className="text-[#6C6768] items-center font-[500] text-[4vw] tsm:text-base mt-1">
									{dayjs(time).format('MMMM')}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-col justify-evenly">
					<div className="">
						<h1 className="text-[#000] font-inter text-[16px] font-[700] leading-[24px] pb-[10px] md:min-w-[372px]">
							{title}
						</h1>
					</div>
					<div className="flex flex-col gap-[8px] w-full">
						<div className="flex items-start gap-[10px]">
							<HiLocationMarker color="#6E71CC" size={24} className="min-w-[24px] min-h-[24px]" />
							<p className="text-[#3B3435] text-[16px] font-inter font-[400] leading-[24px]">{location}</p>
						</div>
						<div className="flex items-start gap-[10px]">
							<HiClock color="#6E71CC" size={24} className="min-w-[24px] min-h-[24px]" />
							<p className="text-[#3B3435] text-[16px] font-inter font-[400] leading-[24px]">
								{endTime && endTime !== "" && endTime !== null
									? `${dayjs(time).format('Do')} - ${dayjs(endTime).format('Do MMM')}`
									: dayjs(time).format('Do MMM')}{' '}10:00am
							</p>
						</div>
						<div className="flex items-start gap-[10px]">
							<PiUsersThreeFill color="#6E71CC" size={24} className="min-w-[24px] min-h-[24px]" />
							<p className="text-[#3B3435] text-[16px] font-inter font-[400] leading-[24px]">
								{`${totalParticipating}${totalParticipating === 100 ? '+' : ''} candidates participating`}
							</p>
						</div>
					</div>
					{/* {!isAccountManagerLoggedIn && isRegistered ? (
						<div className="pt-[12px]">
							<Button type="reset" color="whiteBlueOutline" disabled className="flex-1">
								Registered
							</Button>
						</div>
					) : ( */}
					<div className="pt-[12px]">
						<Button
							type="reset"
							onClick={() => navigate(`/drive-form?drive=${encodeURIComponent(JSON.stringify([id]))}`)}
							color="whiteBlueOutline"
							className="flex-1"
						>
							Register
						</Button>
					</div>
					{/* )} */}
				</div>
			</div>
		</Container>
	);
};

export default UpcomingDriveCard;
